import { render, staticRenderFns } from "./statusPrefix.vue?vue&type=template&id=35761f4d&"
import script from "./statusPrefix.vue?vue&type=script&lang=js&"
export * from "./statusPrefix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports